import React, { Component } from "react";
import Client from "../Client";
import BlackLoading from "../images/black-loader.gif";

class LocallyGrownHolidayPlantsGallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      locallyGrownHolidayPlantsGallerypage: [],
    };
  }

  componentDidMount() {
    Client.getEntries({
      content_type: "locallyGrownHolidayPlantsGallery",
      //'order': 'sys.createdAt'
    }).then((entries) => {
      this.setState({ locallyGrownHolidayPlantsGallerypage: entries.items});
    });
  }


  render() {
    return (
      <div className="container-fluid">
        {this.state.locallyGrownHolidayPlantsGallerypage.length === 0 ?
          <div><img src={BlackLoading} alt="Loading..." /></div> :
              <div className="grid">
                  {this.state.locallyGrownHolidayPlantsGallerypage.map((item, num=0) => {
                      num = num + 1
                      return (
                          <div key={num} className="col-md-4 col-12">
                              <input type="checkbox" id={num} />
                              <label htmlFor={num} className="lightbox"><img src={item.fields.locallyGrownHolidayPlantsGalleryPhoto.fields.file.url} alt="sam bridge christmas photos" /></label>
                              <label htmlFor={num}><img src={item.fields.locallyGrownHolidayPlantsGalleryPhoto.fields.file.url} alt="sam bridge christmas photos" /></label>
                              {/* <p className="text-center">{item.fields.locallyGrownHolidayPlantsGalleryTitle}</p> */}
                          </div>
                      )
                  })}
            </div>
      }

      </div>
    );
  }
}

export default LocallyGrownHolidayPlantsGallery;
